'use strict';

/**
 * Put temporary focus on element, and allow to prevent scrolling
 * @param preventScroll
 */
export default function (preventScroll) {
    const element = this;
    const tabindex = element.getAttribute('tabindex');
    element.addEventListener('blur', function onBlur() {
        tabindex === null && element.removeAttribute('tabindex');
        element.removeEventListener('blur', onBlur);
    });
    tabindex === null && element.setAttribute('tabindex', -1);

    let scrollPositions = new Map();
    if (preventScroll) {
        // save scroll positions
        scrollPositions.set(
            document.scrollingElement,
            [document.scrollingElement.scrollLeft, document.scrollingElement.scrollTop]
        );

        let node = element;
        while (node && node !== document.scrollingElement) {
            if (node.scrollHeight > node.clientHeight) {
                scrollPositions.set(
                    node,
                    [node.scrollLeft, node.scrollTop]
                );
            }
            node = node.parentNode;
        }
    }
    element.focus();
    if (preventScroll) {
        // restore scroll positions
        scrollPositions.forEach(function (positions, node) {
            node.scrollTo.apply(node, positions);
        });
    }

    return true;
}